module.exports = __webpack_public_path__ + "img/google_step_4.f28330d0.jpg";